import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { VrstaKontnogPlana } from './vrsta-kontnog-plana';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-vrsta-kontnog-plana-modal-update',
  templateUrl: './vrsta-kontnog-plana-modal-update.component.html'
})
export class VrstaKontnogPlanaModalUpdateComponent extends BaseModalUpdateComponent<VrstaKontnogPlana> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<VrstaKontnogPlana>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
